import { ligainicial } from "./rutainicial.js";
import { pagesipdus } from "./rutainicial";

const ligabase = ligainicial + "2026/Lic/C";
const ligasipdus = pagesipdus + "2026/Lic/C";
const ligasipdusInv = pagesipdus + "2026/Inv/";

export const licitacionesVigentes = [
    {
        // CONVOCATORIA NUM# 053
        'numConvocatoria' : 'Convocatoria No. 053/2026.',
        'numProcedimiento' : 'EO-SIPDUS-N181-2026.',
        'vigencia' : '2 al 13 de noviembre de 2026.',
        'descripcionProcedimiento' : 'Construcción del Centro Gerontológico Integral de Zapotlán de Juárez (segunda etapa); ubicada en la localidad de Acayuca, Municipio de Zapotlán de Juárez, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }53/N181/N181.rar`,
        'start' : '2026-11-02',
        'end' : '2026-11-13',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N180-2026.',
        'vigencia' : '2 al 13 de noviembre de 2026.',
        'descripcionProcedimiento' : 'Pavimentación e introducción de servicios en Calle 2, Nuevo Parque Industrial en Cd. Sahagún; ubicada en la localidad de Fray Bernardino de Sahagún (Ciudad Sahagún), Municipio de Tepeapulco, Estado de Hidalgo.',
        'urlAnexos' : `${ ligasipdus }53/N180/N180.rar`,
        'start' : '2026-11-02',
        'end' : '2026-11-13',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N179-2026.',
        'vigencia' : '2 al 13 de noviembre de 2026.',
        'descripcionProcedimiento' : 'Pavimentación de circuito Huitexcalco de Morelos, municipio de Chilcuautla.; ubicada en la localidad de Huitexcalco de Morelos, Municipio de Chilcuautla, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }53/N179/N179.rar`,
        'start' : '2026-11-02',
        'end' : '2026-11-13',
        'procedimiento' : 'Licitación Pública',
    },
    {
        // CONVOCATORIA NUM# 052
        'numConvocatoria' : 'Convocatoria No. 052/2026.',
        'numProcedimiento' : 'EO-SIPDUS-N178-2026.',
        'vigencia' : '26 de octubre al 6 de noviembre de 2026.',
        'descripcionProcedimiento' : 'Mantenimiento de Centro Cultural Regional de Tepeapulco; ubicada en la localidad y Municipio de Tepeapulco, Estado de Hidalgo (Segundo procedimiento)',
        'urlAnexos' : `${ ligasipdus }52/N178/N178.rar`,
        'start' : '2026-10-26',
        'end' : '2026-11-06',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N177-2026.',
        'vigencia' : '26 de octubre al 6 de noviembre de 2026.',
        'descripcionProcedimiento' : 'Edificación de oficinas administrativas de la Policía Industrial Bancaria del Estado de Hidalgo (Segunda Etapa); ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }52/N177/N177.rar`,
        'start' : '2026-10-26',
        'end' : '2026-11-06',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N176-2026.',
        'vigencia' : '26 de octubre al 6 de noviembre de 2026.',
        'descripcionProcedimiento' : 'Construcción de barda perimetral en la Concepción.; de Cobertura Estatal',
        'urlAnexos' : `${ ligasipdus }52/N176/N176.rar`,
        'start' : '2026-10-26',
        'end' : '2026-11-06',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N175-2026.',
        'vigencia' : '26 de octubre al 6 de noviembre de 2026.',
        'descripcionProcedimiento' : 'Construcción de muro de contención en calle Gral. Porfirio Rubio y 20 de noviembre, en cabecera municipal de La Misión.; ubicada en la localidad y Municipio de La Misión, Estado de Hidalgo (Segundo procedimiento)',
        'urlAnexos' : `${ ligasipdus }52/N175/N175.rar`,
        'start' : '2026-10-26',
        'end' : '2026-11-06',
        'procedimiento' : 'Licitación Pública',
    },
]